<template>
    <box title='个人信息'>
        <div class="PersonalContent">
            <van-cell @click.stop="Show=true">
                <template>
                    <span class="ImgSpan">图像</span>
                    <div class="PersonalImg">
                        <img :src="PersonalImgUrl" @error="ImgError" @click.stop="ImgClick">
                        <img src="../../assets/img/right.png">
                    </div>

                </template>
            </van-cell>
            <van-cell>
                <Filed title='姓    名' type='input' :text='data.XM' @onMessage="x=>data.XM=x" />
                <Filed title='联系电话' type='input' :text='data.PHONE' @onMessage="x=>data.PHONE=x" />
                <div @click="$Toast('该信息不可更改，有疑问请联系管理员')">
                    <Filed title='工作科室' type='text' :text='data.GZKS?data.GZKS:"暂无"' />
                    <Filed :title='"职    务"' type='text' :text='data.ZWMC?data.ZWMC:"暂无"' />
                    <Filed :title='"角    色"' type='text' :text='data.JSMC?data.JSMC:"暂无"' />
                </div>
            </van-cell>
            <van-cell>
                <template>
                    <div>
                        <span style="font-size: 4vw;color: #14171a;">微信公众号通知</span>
                    </div>
                </template>
            </van-cell>

            <van-checkbox-group v-model="result">
                <van-cell-group>
                    <van-cell v-for="(item, index) in CheckBoxlist" clickable :key="item.name" :title="item.name"
                        @click="toggle(item)">
                        <van-checkbox shape="square" checked-color="#07c160" :name="item.id" ref="checkboxes"
                            slot="right-icon" />
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>

        </div>
        <div class="ButtonContent" @click="PersonalButton">
            <span>完成</span>
        </div>
        <transition name="fade">
            <van-popup v-model="Show" round position="bottom" :style="{width:'100%',height:'100px'}">
                <div class="PersonalImgUploader">
                    <span>请选择上传图像</span>
                    <van-uploader icon="photo" :after-read="afterRead" max-size="10485760"
                        @oversize="$Toast('上传图片大小超过限制，不能超过10MB')" />
                </div>
            </van-popup>
        </transition>

        <transition name="fade">
            <div>
                <van-popup v-model="CropperShow" closeable round position="bottom" :style="{width:'100%',height:'50%'}">
                    <vueCropper ref="cropper" :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight" :img="option.img" :outputSize="option.outputSize"
                        :outputType="option.outputType" :info="true" :full="option.full" :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop"
                        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue" :fixedBox="option.fixedBox" :enlarge="option.enlarge"
                        :maxImgSize='option.maxImgSize' />
                    <!-- <div class="CropperButton" @click="CropperClick"><span>完成</span></div> -->
                </van-popup>
            </div>
        </transition>
    </box>
</template>
<script>
    import Vue from 'vue'
    import Box from '../../components/commonBox/commonBox'
    import Filed from '../../components/field/field.vue'
    import VueCropper from 'vue-cropper'
    Vue.use(VueCropper)
    import {
        popup,
        cell,
        ImagePreview,
        Uploader,
        Image,
        Loading,
        Checkbox,
        CheckboxGroup,
        CellGroup,

    } from 'vant'
    export default {
        name: 'Personal',
        components: {
            Box,
            Filed,
            [popup.name]: popup,
            [cell.name]: cell,
            [Uploader.name]: Uploader,
            [Image.name]: Image,
            [Loading.name]: Loading,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [CellGroup.name]: CellGroup
        },
        data() {
            return {
                data: {},
                PersonalImgUrl: null,
                Show: false, //上传隐显
                CropperShow: false, //截图隐显
                option: {
                    img: '',
                    autoCropWidth: 80,
                    autoCropHeight: 80,
                    outputSize: 0.1, //剪切后的图片质量（0.1-1）
                    full: false, //输出原图比例截图 props名full
                    outputType: 'png',
                    canMove: true,
                    original: false,
                    canMoveBox: false,
                    infoTrue: false,
                    fixedNumber: [1, 1],
                    autoCrop: true,
                    fixedBox: false,
                    fixed: true,
                    enlarge: 1,
                    centerBox: true,
                },
                CheckBoxlist: [{
                    id: 'PGTX',
                    name: '派工提醒'
                }, {
                    id: 'JDTX',
                    name: '接单提醒'
                }, {
                    id: 'WXTX',
                    name: '维修提醒'
                }, {
                    id: 'SPTX',
                    name: '审批提醒'
                }, {
                    id: 'YSTX',
                    name: '验收提醒'
                }], //复选框选中值
                result: []
            }
        },
        mounted() {
                    this.PersonalImgUrl = this.$UserInfo.PersonalImage + '?' + this.$getRandomNumber(5); this
                    . loadDataDefault();
                },
                methods: {
                    loadDataDefault() {
                        this.$get('api/Property/GetPersonalInfo', {
                            GKHM: this.$UserInfo.UserId
                        }).then(result => {
                            try {
                                var model = JSON.parse(result);
                                if (model.length > 0) {
                                    this.data = model[0];
                                    for (let i = 0; i < this.CheckBoxlist.length; i++) {
                                        if (this.data[this.CheckBoxlist[i].id] == "1") {
                                            this.result.push(this.CheckBoxlist[i].id);
                                        }
                                    }
                                }
                            } catch (e) {}
                        })
                    },
                    ImgError() {
                        this.PersonalImgUrl = require('../../assets/img/header.png');
                    },
                    ImgClick() {
                        var data = [];
                        data.push(this.PersonalImgUrl)
                        ImagePreview({
                            images: data,
                            startPosition: 0,
                            swipeDuration: 10000,
                            closeOnPopstate: true,
                        })
                    },
                    afterRead(obj) {

                        var baseUrl = URL.createObjectURL(obj.file);
                        // var image = new Image();
                        // image.src ='http://www.api.zlianyx.com/Photo/Home_3.jpg';


                        this.option.img = baseUrl;
                        this.CropperShow = true;
                        this.Show = false;
                    },
                    CropperClick() {
                        this.$refs.cropper.getCropData((data) => {
                            this.$post('api/Property/PersonalUploading', {
                                base64Str1: data,
                                Token: this.$UserInfo.UserId
                            },{timeout:100000}).then(result => {
                                if (result.Status) {
                                    this.$Toast({
                                        message: '上传成功!',
                                        duration: 1500,
                                        onClose: () => {
                                            this.CropperShow = false;
                                            this.GetDynamicImgUrl();
                                        }
                                    })
                                } else this.$Toast('上传失败!')
                            })
                        })
                    },
                    GetDynamicImgUrl() {
                        this.$get('api/Property/GetDynamicImgUrl', {
                            GKHM: this.$UserInfo.UserId,
                            Status: "1"
                        }).then(result => {
                            if (result) {
                                let randomUrl = result + '?' + this.$getRandomNumber(5);
                                this.$UserInfo.PersonalImage = randomUrl;
                                Vue.prototype.$UserInfo = this.$UserInfo;
                                localStorage.setItem('userInfo', JSON.stringify(this.$UserInfo)); //重新存放User对象
                                this.PersonalImgUrl = randomUrl;
                            } else this.$Toast('系统异常,请联系管理员!')
                        })
                    },

                    PersonalButton() {
                        if (this.data.XM == "") {
                            this.$Toast('姓名不能为空!')
                            return false;
                        }
                        if (this.data.PHONE == "") {
                            this.$Toast("联系电话不能为空!");
                            return false;
                        }
                        for (var i = 0; i < this.CheckBoxlist.length; i++) {
                            if (this.result.findIndex(x => x == this.CheckBoxlist[i].id) != -1) {
                                this.data[this.CheckBoxlist[i].id] = "1";
                            } else this.data[this.CheckBoxlist[i].id] = "";
                        }
                        this.$get('api/Property/ModifyPersonal', {
                            GKHM: this.$UserInfo.UserId,
                            XM: this.data.XM,
                            PHONE: this.data.PHONE,
                            PGTX: this.data.PGTX,
                            JDTX: this.data.JDTX,
                            WXTX: this.data.WXTX,
                            SPTX: this.data.SPTX,
                            YSTX: this.data.YSTX
                        }).then(result => {
                            if (result == "Y") {
                                this.$Toast('修改成功!');
                            } else this.$Toast('修改失败,请稍后再试!');
                        })
                    },
                    scrollHandle(e) {
                        console.log(e);
                    }
                },
                watch: {}
        }
</script>

<style scoped lang="scss">
    .PersonalContent {
        .ImgSpan {
            letter-spacing: 0.5em;
            font-size: 4vw;
            position: absolute;
            top: 30px;
        }

        .PersonalImg {
            float: right;

            &>img {
                &:first-child {
                    border-radius: 1em;
                    width: 90px;
                    height: 90px;
                }

                &:last-child {
                    margin-bottom: 15px;
                    width: 50px;
                    height: 50px;
                }
            }
        }
    }

    .PersonalImgUploader {
        text-align: center;

        span {
            margin-top: 20px;
            display: block;
        }
    }

    .CropperButton {
        background: #4FA69E;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 80px;
        color: #fff;
        text-align: center;

        span {
            position: absolute;
            left: 0px;
            right: 0px;
            top: 15px;
        }
    }

    .ButtonContent {
        width: 100%;
        height: 60px;
        background: #4FA69E;
        color: #FFFFFF;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/page/Personal/Personal.vue